var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongGengduo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_gengduo2_svg__clip0_5179_55174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.666 8.75a.75.75 0 100-1.5.75.75 0 000 1.5zM8 8.75a.75.75 0 100-1.5.75.75 0 000 1.5zM11.334 8.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_gengduo2_svg__clip0_5179_55174"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_gengduo2.491ffaac.svg";
export { SvgTongyongGengduo2 as ReactComponent };